import { Component, OnInit, Output, EventEmitter } from "@angular/core";
import { NavService, Menu } from "../../services/nav.service";
import { AuthService } from "../../services/firebase/auth.service";
import { Router } from "@angular/router";
import { NetsolinService } from "../../services/netsolin.service";

@Component({
  selector: "app-header-monitornet",
  templateUrl: "./header-monitornet.component.html",
  styleUrls: ["./header-monitornet.component.scss"],
})
export class HeaderMonitornetComponent implements OnInit {
  public menuItems: Menu[];
  public items: Menu[];
  public openNav: boolean = false;
  public right_sidebar: boolean = false;
  public text: string;
  public varprimary = "primary";
  public ano = "2022";
  public periodo = "1";
  public iterano = [0, 1, 2, 3, 4];
  public itermes = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];
  public cargoheadbar = false;
  public monitores: Array<any> = [];
  public reportes: Array<any> = [];
  public personalizados: Array<any> = [];
  public procesos: Array<any> = [];
  @Output() rightSidebarEvent = new EventEmitter<boolean>();

  constructor(
    public navServices: NavService,
    public authService: AuthService,
    private router: Router,
    private netsolinService: NetsolinService
  ) {
    var fechacto = new Date();
    this.ano = fechacto.getFullYear().toString();
    this.cargarModuloMenu();
    this.cargoheadbar = true;
  }

  ngOnInit() {
    this.navServices.items.subscribe((menuItems) => {
      this.items = menuItems;
    });
  }

  private cargarModuloMenu() {
    this.netsolinService.getModulosWebSolinNetsolin().then((res: any) => {
      console.log("Modulos web cargados.", res);
      var monitores = [];
      var reportes = [];
      var personalizados = [];
      var procesos = [];
      for (let modulo of res.modulos) {
        var objmenweb = {
          text: modulo.nombre,
          icon: modulo.grafico,
          click: () => {
            var link = this.formatLink(modulo.info_deta); //Llama funcion que formatea el link
            link = decodeURI(link);
            link = encodeURIComponent(link);
            console.log("URL objhtml ->", link);
            this.router.navigate(["objhtml/" + link]);
          },
        };
        if(modulo.codigo.indexOf('MON')!=-1){//ES UN MONITOR
          monitores.push(objmenweb);
        };
        if(modulo.codigo.indexOf('REP')!=-1){//ES UN REPORTE
          reportes.push(objmenweb)
        };
        if(modulo.codigo.indexOf('PER')!=-1){//ES UN PERSONALIZADO
          personalizados.push(objmenweb);
        };
        if(modulo.codigo.indexOf('PRO')!=-1){//ES UN PROCESO
          procesos.push(objmenweb);
        };
      }
      this.monitores = monitores;
      this.reportes = reportes;
      this.personalizados = personalizados;
      this.procesos = procesos;
    }, (error:any) => {
      console.log('Error al traer modulos ',error);
  });
  }


  private formatLink(link){//Formatear los links de NETSOLIN y Llena variables como PVXIANO, PVXIPERIODO
    link = link.replace('[ano]', this.ano);
    link = link.replace('[periodo]', this.periodo);
    return link;
  }

  public onPaste(): void {
    console.log("Paste");
  }

  collapseSidebar() {
    this.navServices.collapseSidebar = !this.navServices.collapseSidebar;
  }

  collapseUserSidebar() {
    this.navServices.collapseUserSidebar =
      !this.navServices.collapseUserSidebar;
    document.getElementsByTagName("html")[0].classList.toggle("less");
    console.log(document.getElementsByTagName("html")[0]);
  }
}
